import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import { loadUserPermissionsFailure, loadUserPermissionsSuccess } from './permissions.actions';
import { State } from './permissions.state';

export const initialState: State = {
  UserPermissions : null
};

const adapterPermissions =
  createEntityAdapter<string>({ selectId: c => c });
  
export const permissionsReducer = createReducer(
  initialState,
  
  on(loadUserPermissionsSuccess, (state, result) =>
    ({
    ...state,
    UserPermissions: result.userPermissions
    })),
    on(loadUserPermissionsFailure, (state, { error }) =>
    {
      return {
        ...state,
        error: error
      };
    })
  );
  
  
  export function reducer(state = initialState, action: Action): State
  {
    return permissionsReducer(state, action);
  }